var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.app)?_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-spinner',{attrs:{"variant":"light"}})],1)],1):_c('div',[_c('b-col',{attrs:{"cols":"12"}},[_c('PowerApp',{attrs:{"dist":_vm.app.dist,"app":_vm.app}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }